import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { VarianDataPayload, VarianDataResponse } from "@/types/interface/varian";

export const useVarianStore = defineStore("varianStore", () => {
  const varian = ref<VarianDataResponse>();
  const varians = ref<VarianDataResponse[]>([]);

  function initVarians(data: any) {
    varians.value = data?.data;
  }

  function addNewVarian(data: any) {
    varian.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.varian.getVarian(page, limit, queryParam);
      initVarians(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchDetail(idVendor = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.varian.findVarian(idVendor);
      addNewVarian(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchCreate(payload: VarianDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.varian.createVarian(payload);
      addNewVarian(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchUpdate(idVendor = "", payload: VarianDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.varian.updateVarian(idVendor, payload);
      addNewVarian(data);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  async function dispatchDelete(idVendor = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.varian.deleteVarian(idVendor);
      return handleResponse(status, data);
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
  }

  return {
    varian,
    varians,
    initVarians,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});